declare namespace $ {

	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_reactboard_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['rows_heart'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_reactboard_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['rows_smile'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_reactboard_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['rows_fire'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_reactboard_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['rows_clap'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_reactboard_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['rows_poop'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['row_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_reactboard_17 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_reactboard['row_count'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_reactboard_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_blitz_lobby_game_reactboard extends $mol_view {
		Title_heart( ): $mol_paragraph
		rows_heart( ): readonly(any)[]
		List_heart( ): $mol_list
		Table_heart( ): $mol_view
		Title_smile( ): $mol_paragraph
		rows_smile( ): readonly(any)[]
		List_smile( ): $mol_list
		Table_smile( ): $mol_view
		Title_fire( ): $mol_paragraph
		rows_fire( ): readonly(any)[]
		List_fire( ): $mol_list
		Table_fire( ): $mol_view
		Title_clap( ): $mol_paragraph
		rows_clap( ): readonly(any)[]
		List_clap( ): $mol_list
		Table_clap( ): $mol_view
		Title_poop( ): $mol_paragraph
		rows_poop( ): readonly(any)[]
		List_poop( ): $mol_list
		Table_poop( ): $mol_view
		row_name( id: any): string
		Row_name( id: any): $mol_paragraph
		row_count( id: any): string
		Row_count( id: any): $mol_paragraph
		players_dict( ): any
		sub( ): readonly(any)[]
		Row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=reactboard.view.tree.d.ts.map